import React from "react";
import moment from "moment";
import { convertToPresentableText } from "../../../utils/functions";
import { Chip } from "@material-tailwind/react";
import { Link } from "react-router-dom";
import { InterpretLeadStatus } from "../../../utils/ui-interpreters";
import { LEVELS } from "../../../utils/enums";

const LeadSummary = ({ formData }) => {
  return (
    <>
      <div className="mb-4">
        <h4 className="font-medium mb-2">Basic Information</h4>
        <div className="grid grid-cols-2 gap-2">
          <div>
            <span className="text-xs text-gray-500">Name:</span>
            <p className="text-sm">{formData.fullName}</p>
          </div>
          <div>
            <span className="text-xs text-gray-500">Job Title:</span>
            <p className="text-sm">{formData.jobTitle || 'N/A'}</p>
          </div>
          <div>
            <span className="text-xs text-gray-500">Email:</span>
            <p className="text-sm">{formData.emailAddress}</p>
          </div>
          <div>
            <span className="text-xs text-gray-500">Phone:</span>
            <p className="text-sm">{formData.phoneNumber || 'N/A'}</p>
          </div>
          <div>
            <span className="text-xs text-gray-500">Company:</span>
            <p className="text-sm">{formData.companyName}</p>
          </div>
          <div>
            <span className="text-xs text-gray-500">Status:</span>
            <div className="flex">
              {InterpretLeadStatus(formData.leadStatus)}
            </div>
          </div>
        </div>
      </div>

      <div className="mb-4">
        <h4 className="font-medium mb-2">Lead Quality</h4>
        <div className="grid grid-cols-2 gap-2">
          <div>
            <span className="text-xs text-gray-500">Score:</span>
            <p className="text-sm">{formData.score || '0'}/100</p>
          </div>
          <div>
            <span className="text-xs text-gray-500">Engagement Level:</span>
            <div className="flex">
              <Chip
                value={convertToPresentableText(formData.engagementLevel)}
                color={
                  formData.engagementLevel === LEVELS.LOW ? 'blue' :
                    formData.engagementLevel === LEVELS.MEDIUM ? 'indigo' :
                      formData.engagementLevel === LEVELS.HIGH ? 'purple' :
                        'gray'
                }
                className="py-1 px-2 text-xs"
              />
            </div>
          </div>
          <div>
            <span className="text-xs text-gray-500">Purchase Intent:</span>
            <div className="flex">
              <Chip
                value={convertToPresentableText(formData.purchaseIntent || 'N/A')}
                color={
                  formData.purchaseIntent === LEVELS.LOW ? 'blue' :
                    formData.purchaseIntent === LEVELS.MEDIUM ? 'indigo' :
                      formData.purchaseIntent === LEVELS.HIGH ? 'purple' :
                        'gray'
                }
                className="py-1 px-2 text-xs"
              />
            </div>
          </div>
          <div>
            <span className="text-xs text-gray-500">Budget Range:</span>
            <p className="text-sm">{convertToPresentableText(formData.budgetRange.split(':')[2] || 'N/A')}</p>
          </div>
        </div>
      </div>

      {formData.engagementHistory && formData.engagementHistory.length > 0 && (
        <div className="mb-4">
          <h4 className="font-medium mb-2">Recent Engagements</h4>
          <div className="space-y-2 max-h-40 overflow-y-auto">
            {formData.engagementHistory.slice().reverse().map((engagement, index) => (
              <div key={index} className="px-4 py-2 bg-blue-50 rounded-xl text-sm">
                <div className="flex justify-between">
                  <span className="font-medium">{convertToPresentableText(engagement.contactMethod)} by {engagement.by?.name}</span>
                  <span className="text-xs text-gray-900">{moment(engagement.date).format('lll')}</span>
                </div>
                <p className="text-xs mt-1">Notes: {engagement.notes}</p>
                <p className="text-xs mt-1">Outcome: {engagement.outcome}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="mb-4">
        <h4 className="font-medium mb-2">Next Actions</h4>
        <div>
          <span className="text-xs text-gray-500">Next Action:</span>
          <p className="text-sm">{formData.nextAction || 'None scheduled'}</p>
        </div>
        {formData.actionDueDate && (
          <div className="mt-1">
            <span className="text-xs text-gray-500">Due Date:</span>
            <p className="text-sm">{moment(formData.actionDueDate).format('MMM D, YYYY')}</p>
          </div>
        )}
        <div className="mt-1">
          <span className="text-xs text-gray-500">Priority:</span>
          <p className="text-sm">{convertToPresentableText(formData.followUpPriority)}</p>
        </div>
      </div>

      {formData.tags && formData.tags.length > 0 && (
        <div className="mb-4">
          <h4 className="font-medium mb-2">Tags</h4>
          <div className="flex flex-wrap gap-1">
            {formData.tags.map((tag, index) => (
              <span key={index} className="bg-blue-50 text-blue-700 text-xs px-2 py-1 rounded-full">
                {tag}
              </span>
            ))}
          </div>
        </div>
      )}
      <div className={`flex gap-1`}>
        Last contacted on {moment(formData.lastContacted).format('MMM D, YYYY')} by
        <Link to={`/user/${formData?.updatedBy?._id}`} className="text-blue-500">{formData?.updatedBy?.name}</Link>
      </div>
    </>
  );
};

export default LeadSummary;